module.exports = __webpack_public_path__ + "img/fairy.603e08d1.svg";